module.exports = __webpack_public_path__ + "img/keith.a58afe96.jpeg";